<template>
 <span class="inline-block h-max text-xs rounded-xl py-1 px-3 font-bold" v-if="loyaltyPointsData"
       :style="{'background':cardType?.background}">
   <div :style="{'color':cardType?.color}"> {{ loyaltyPointsData?.value }}</div>  
  </span>
</template>

<script setup>

const props = defineProps({
  data: {
    type: Object,
    default: () => {
    }
  },
  selectedOption: {
    type: Object,
    default: () => {
    }
  }
});

const cardDesign = {
  1: {background: "#E6E6E6", color: "#575353", forgroundColor: '#504F4F33', iconColor: '#fff'},
  2: {background: "#CE9C3A", color: "#fff", forgroundColor: '#DAB162', iconColor: '#A17622'},
  3: {background: "#151515", color: "#fff", forgroundColor: '#272828', iconColor: '#fff'}
};
const cardType = computed(() => cardDesign[props?.data?.loyalty_details?.points?.type] || {
  background: "#E6E6E6",
  color: "#575353",
  forgroundColor: '#504F4F33',
  iconColor: '#fff'
});

const selectedProductOption = computed(() => props.selectedOption?.defaultOption || props.selectedOption?.secondaryOption)
const loyaltyPointsData = computed(() => selectedProductOption.value?.loyalty_details?.points || props.data?.loyalty_details?.points)
</script>


